import { service } from "./service";

export function getPropertyDetailsApi(payload) {
  return service.get(`v3/properties/${payload.propertyId}`);
}

export function getPropertyBasicDetailsApi(propertyId) {
  return service.get(`v3/properties/${propertyId}/basic-details`);
}

export function getPropertyImagesApi(propertyId) {
  return service.get(`v3/properties/${propertyId}/images`);
}

export function getPropertyNearbyPlacesApi(propertyId) {
  return service.get(`v3/properties/${propertyId}/nearby-places`);
}

export function getPropertyPoliciesApi(propertyId) {
  return service.get(`v3/properties/${propertyId}/policies`);
}

export function getPropertyPaymentTaxDetailsApi(propertyId) {
  return service.get(`v3/properties/${propertyId}/payment-tax-details`);
}

export function getPropertyAiReviewSummaryApi(propertyId) {
  return service.get(`v3/properties/${propertyId}/ai-review-summary`);
}

export function getPropertyWishlistStatusApi(propertyId) {
  return service.get(`v3/properties/${propertyId}/wishlist-status`);
}
export function getPropertyFacilitiesApi(propertyId) {
  return service.get(`v3/properties/${propertyId}/facilities`);
}

export function getPropertyRoomApi(propertyId) {
  return service.get(`v3/properties/${propertyId}/room-details`);
}

export function getAvailablePropertyRoomsApi(payload) {
  const { propertyId, checkin, checkout, adultCount, childCount, childAges = [] } = payload;

  const baseUrl = `v3/properties/${propertyId}/availability`;

  const searchParamsPayload = {
    checkin,
    checkout,
    adultCount,
    childCount: childCount || 0,
  };

  if (childAges.length > 0) {
    searchParamsPayload.childAges = childAges.join(",");
  }

  const queryParams = new URLSearchParams(searchParamsPayload).toString();

  return service.get(`${baseUrl}?${queryParams}`);
}

export function getPropertyOffersApi(payload) {
  const { propertyId, checkin, checkout } = payload;
  return service.get(`v3/properties/${propertyId}/offers?checkin=${checkin}&checkout=${checkout}`);
}

export function getSingleRoomApi(payload) {
  const { propertyId, roomId } = payload;
  return service.get(`v3/properties/${propertyId}/rooms/${roomId}`);
}

export function getPropertyReviewsApi(payload) {
  const { propertyId, page, pageSize } = payload;
  return service.get(`v3/properties/${propertyId}/reviews`, {
    params: {
      page,
      pageSize,
    },
  });
}

export function getLikedPropertiesApi(payload) {
  return service.post(`v3/properties/user-like-lookup`, payload);
}

export function likePropertyApi({ propertyId }) {
  return service.post(`v3/properties/${propertyId}/like`);
}

export function dislikePropertyApi({ propertyId }) {
  return service.delete(`v3/properties/${propertyId}/like`);
}

export function getPropertiesByDestinationApi(payload) {
  return service.get(`v3/properties/destinations`, {
    params: payload,
  });
}

function serializeQuery(query) {
  return Object.keys(query)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(JSON.stringify(query[key]))}`)
    .join("&");
}

export function searchPropertiesByDestinationApi(query) {
  const queryString = serializeQuery(query);
  return service.get(`v3/properties/destinations/map?${queryString}`);
}
